import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";

export interface FacilityTypesRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: FacilityTypesRoute[];
}

export const facilityTypesRoutes: FacilityTypesRoute[] = [
  {
    path: "/ax/settings/facility-types",
    element: <Landing />,
  },
];